<template lang="pug">
  .burger-menu.hide-sm-up(
    @click.self="$emit('close')"
  )
    .burger-menu__body
      .burger-menu__header
        .burger-menu__logo
          img.logo-adaptive(
            src="@/assets/images/logo/logo-color-adaptive.svg"
          )
      .burger-menu__nav
        main-nav(
          :user-data="userData"
          @setShowAuthModal="$emit('setShowAuthModal')"
        )
      //- .burger-menu__lang
      //-   lang-select(
      //-     :lang="lang"
      //-   )
</template>

<script>
import {mapState} from "vuex";
import UserDropdown from "./UserDropdown";
import MainNav from "./Nav";
import LangSelect from "./LangSelect";

export default {
  name: "BurgerMenu",
  components: {LangSelect, MainNav, UserDropdown},
  computed: {
    ...mapState(["translation"])
  },
  props: ["userData", "lang"],
  methods: {
    cancelScroll() {
      window.scrollTo(0, 0);
    }
  },
  data() {
    return {};
  },
  mounted() {
    window.addEventListener("scroll", this.cancelScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.cancelScroll);
  }
};
</script>
